import { render } from "./SearchBarVue.vue?vue&type=template&id=6d8bd6a8&scoped=true"
import script from "./SearchBarVue.vue?vue&type=script&lang=js"
export * from "./SearchBarVue.vue?vue&type=script&lang=js"

import "./SearchBarVue.vue?vue&type=style&index=0&id=6d8bd6a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8bd6a8"]])

export default __exports__